import React, { memo, useCallback, useState, useRef, useMemo, ReactNode } from 'react';
import { Accordion, AccordionBody, AccordionHeader } from './components/Accordion';
import { IAccordion } from 'constants/MultipleAcorddions';
import { AccordionItem, ExpandedIndex, Heading } from '@chakra-ui/react';

interface IProps {
  accordions?: IAccordion[];
  children?: ReactNode;
  runOnChange: Function;
  allowMultiple?: boolean;
  completed?: boolean;
  expand?: number[];
}

function findPos(obj: HTMLElement) {
  return obj.offsetTop - obj.offsetHeight;
}

const MultipleAccordionComponent: React.FC<IProps> = ({
  accordions,
  runOnChange,
  allowMultiple,
  completed,
  children,
  expand,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ...props
}) => {
  const [currentIndex, setCurrentIndex] = useState<ExpandedIndex>(0);
  const disableds = useMemo(() => accordions?.map(el => el.disabled), []) as any;
  const elsRef = useRef<{ els: Array<HTMLHeadingElement | null> }>({
    els: [],
  });

  const functionCB = useCallback((i: ExpandedIndex) => {
    if ((i as number) < disableds.length) {
      disableds[i as number] = false;
      disableds[(i as number) + 1] = false;
      disableds[(i as number) - 1] = false;
    }
    setCurrentIndex(i);

    // window.scrollTo(0, elsRef.current.els[i as number] || 0);
    const el = elsRef.current.els[i as number]?.parentElement;
    setTimeout(() => {
      window.scrollTo(0, (el ? findPos(el) : undefined) || 0);
    }, 400);
  }, []);

  return (
    <Accordion
      mb="1em"
      index={!allowMultiple ? currentIndex : undefined}
      allowMultiple={!!allowMultiple}
      defaultIndex={expand || (allowMultiple ? accordions?.map((_, k) => k) : undefined)}
      onChange={i => setCurrentIndex(i)}
      boxShadow="none"
    >
      {typeof accordions === 'object'
        ? accordions.map((value, index) => {
            return (
              <AccordionItem
                border="none"
                key={index}
                index={index}
                isDisabled={completed ? false : disableds[index]}
              >
                <AccordionHeader index={index + 1}>
                  <Heading
                    ref={el => {
                      elsRef.current.els[index] = el;
                    }}
                    size="sm"
                  >
                    {value.title}
                  </Heading>
                </AccordionHeader>
                <AccordionBody>
                  {value.body({
                    index: index,
                    functionCallback: functionCB,
                    submit: runOnChange,
                    completed,
                  })}
                </AccordionBody>
              </AccordionItem>
            );
          })
        : children}
    </Accordion>
  );
};

export const MultipleAccordion = memo(MultipleAccordionComponent);
